<template>
<Title/>
	<div class="container">
		<div class="card mt-5 mb-5 p-3">
			<div style="font-size:small" v-html="compiledHtml"></div>
		</div>
	</div>
</template>
  
<script>
import axios from 'axios';
import Title from '../../../components/Title.vue'

export default {
	data() {
		return {
			input: "",
		}
	},
	components: {
		Title
	},

	created() {
		this.fileName = this.$route.params.fileName;
		this.loadFile()
	},

	computed: {
		compiledHtml: function () {
			return this.input;
		}
	},

	methods: {

		loadFile() {
			axios({
				method: "get",
				url: "https://www.executori.ro/api/public/static/files/proiecte/cariera.html"
			})
				.then(result => {
					this.input = result.data;
				})
				.catch(error => {
					console.error("eroare");
				});
		}
	},
}
</script>
  